import React from "react";
import PropTypes from "prop-types";
import { TableRow, TableCell } from "semantic-ui-react";

import styles from "./styles.css";


const ErrorRow = ({ children }) => {
	return (
		<TableRow data-component="Table\ErrorRow" className={styles.errorRow}>
			<TableCell colSpan={1000}>
				{children}
			</TableCell>
		</TableRow>
	);
};

ErrorRow.propTypes = {
	children: PropTypes.node
};

export default ErrorRow;